import { render } from "./PlatformConfiguration.vue?vue&type=template&id=745d60c2&scoped=true"
import script from "./PlatformConfiguration.vue?vue&type=script&lang=js"
export * from "./PlatformConfiguration.vue?vue&type=script&lang=js"

import "./PlatformConfiguration.vue?vue&type=style&index=0&id=745d60c2&lang=less"
import "./PlatformConfiguration.vue?vue&type=style&index=1&id=745d60c2&lang=less&scoped=true"

import exportComponent from "F:\\workspace\\clientapps\\Advertising-Platform\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-745d60c2"]])

export default __exports__